module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_engagement-location-photo-2-0729d8c945fb047b457e22fa778d327f.png";